import { INodeMapping, IVersionMappingUpdate } from '../tree/TreeActions'
import { INode } from 'shared/types/tree'
import * as React from 'react'
import { Box, Button } from '@mui/material'
import { SingleMapping } from './SingleMapping'
import { NodeIdMap } from './utility'

export function ManualMapping({
  missingMapping,
  sourceIdMapping,
  destinationMapping,
  updateMappingFunc,
  destination,
  sourceTree,
}: {
  missingMapping: INodeMapping[]
  sourceIdMapping: NodeIdMap
  destinationMapping: NodeIdMap
  destination: INode
  sourceTree: INode
  updateMappingFunc: (updateInfo: IVersionMappingUpdate) => void
}) {
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const [currentSource, setCurrentSource] = React.useState<{
    node: INode
    path: string
  }>()

  React.useEffect(() => {
    if (!missingMapping.length) return
    const currentNodeId = missingMapping[currentIndex].from_node_id
    const { node, treePath: path } = sourceIdMapping[currentNodeId]
    setCurrentSource({ node, path })
  }, [currentIndex, sourceIdMapping, missingMapping])

  if (!missingMapping.length) {
    return <Box>Mapping is complete</Box>
  }

  const next = () => {
    if (currentIndex < missingMapping.length - 1) {
      setCurrentIndex(currentIndex + 1)
    } else {
      setCurrentIndex(0)
    }
  }
  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    } else {
      setCurrentIndex(missingMapping.length - 1)
    }
  }

  return (
    <Box>
      {currentSource && (
        <SingleMapping
          mapping={missingMapping[currentIndex]}
          source={currentSource}
          destinationMap={destinationMapping}
          updateMappingFunc={updateMappingFunc}
          destinationTree={destination}
          sourceTree={sourceTree}
        />
      )}
      <Box border={'1px solid'} width={'135px'}>
        <Button onClick={prev}>{'<-'}</Button>
        <Button onClick={next}>{'->'}</Button>
      </Box>
    </Box>
  )
}
